import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import dynamic from 'next/dynamic';
import { Button } from '@zydalabs/zac-react';
import { useUpdateModal } from '@zydalabs/storefront-components';
import useTranslation from 'next-translate/useTranslation';

import { usePersistedRecipientInfo } from 'common/hooks';
import { customHistory, localizeErrorMessages } from 'common/utils';
import GiftForm from '../GiftForm/GiftForm';
import { StyledGiftOrderingContentWrapper, StyledGiftOrderingWrapper } from './styles';
import giftValidation from '../GiftForm/validation';

const StoreFrontHeaderComponent = dynamic(() => import('common/components/StoreFrontHeader'));

const GiftOrdering = () => {
  const { t } = useTranslation('checkout');
  const [persistedRecipientInfo, setPersistedRecipientInfo, removePersistedRecipientInfo] = usePersistedRecipientInfo();
  const updateModal = useUpdateModal();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(giftValidation),
    defaultValues: persistedRecipientInfo,
  });

  const fields = {
    name: t('fullName'),
    phoneNumber: t('phoneNumber'),
    giftNotes: t('giftNote'),
  };

  const handleOnSubmit = data => {
    setPersistedRecipientInfo(data);
    customHistory.back();
  };

  const handleOnRemove = () => {
    updateModal({
      isOpen: true,
      showCloseIcon: true,
      description: t('sureToRemoveRecipient'),
      confirmButtonText: `${t('yes')}${t('comma')}${t('removeRecipient')}`,
      onConfirm: onModalConfirm,
      onClose: () => updateModal({ isOpen: false }),
    });
  };

  const onModalConfirm = () => {
    removePersistedRecipientInfo();
    customHistory.back();
  };

  return (
    <StyledGiftOrderingWrapper>
      <StoreFrontHeaderComponent title={t('recipientInfo')} />
      <StyledGiftOrderingContentWrapper>
        <GiftForm fields={fields} errors={localizeErrorMessages(t, fields, errors)} control={control} />
        <Button
          testId="save_gift_order"
          isFluid
          text={t('save')}
          onClick={handleSubmit(handleOnSubmit)}
        />
        {persistedRecipientInfo && (
          <Button
            testId="remove_recipient_btn"
            isFluid
            variant="tertiary"
            text={t('removeRecipient')}
            onClick={handleOnRemove}
          />
        )}
      </StyledGiftOrderingContentWrapper>
    </StyledGiftOrderingWrapper>
  );
};

export default GiftOrdering;
